const map = {
	"./about.json": 2789,
	"./conditions-commande.json": 9677,
	"./contact.json": 920,
	"./hero.json": 3060,
	"./logo-cadrage.json": 4303,
	"./mentions-legales.json": 3999,
	"./realisations/18-ans-en-rose.json": 355,
	"./realisations/anniversaire-en-musique.json": 8086,
	"./realisations/echec-et-bon-appetit.json": 8349,
	"./realisations/gateau-kitty.json": 7248,
	"./realisations/ils-se-sont-dit-oui-autour-dune-piece-montee.json": 6879,
	"./realisations/le-ballon-rond-a-lhonneur.json": 975,
	"./realisations/le-gateau-roblox.json": 3627,
	"./realisations/mickey-sinvite-a-la-fete.json": 9451,
	"./realisations/un-anniversaire-avec-stitch.json": 6202,
	"./realisations/un-bapteme-memorable.json": 2206,
	"./realisations/un-cap-des-20-ans-celebre-en-douceur.json": 615,
	"./realisations/un-gateau-aux-couleurs-de-lac-milan.json": 2111,
	"./realisations/un-gateau-de-mariage-tout-en-fleurs.json": 5696,
	"./realisations/un-mariage-a-moto.json": 2989,
	"./realisations/un-mariage-en-toute-simplicite.json": 2691,
	"./realisations/un-mariage-tout-en-elegance.json": 9367,
	"./realisations/un-nouveau-chapitre-a-30-ans.json": 6276,
	"./realisations/un-wedding-cake-aux-fleurs-roses.json": 8320,
	"./realisations/une-chemise-haute-en-couleurs.json": 2771,
	"./realisations/une-fete-pleine-de-douceur.json": 1850,
	"./realisations/une-piece-montee-pleine-de-fantaisie.json": 4650,
	"./realisations/une-piece-montee-qui-donne-le-sourire.json": 3010,
	"./tarifs/bento-cake.json": 1281,
	"./tarifs/biscuits-sables.json": 4619,
	"./tarifs/bonbon-sucettes-personnalisees.json": 4037,
	"./tarifs/choux-a-la-creme.json": 8196,
	"./tarifs/cupcakes.json": 7795,
	"./tarifs/gateau-anniversaire.json": 4597,
	"./tarifs/gateau-suspendu-ou-inverse.json": 1977,
	"./tarifs/layer-cake.json": 9558,
	"./tarifs/macarons.json": 6872,
	"./tarifs/magnum-cakes.json": 8723,
	"./tarifs/number-letter-cake.json": 9981,
	"./tarifs/pop-cakes.json": 3453,
	"./tarifs/wedding-cake.json": 9077,
	"./testimonials/aminata-diallo.json": 2432,
	"./testimonials/baudouin-kolingba.json": 9302,
	"./testimonials/claire-lefebvre.json": 7911,
	"./testimonials/fatou-ndiaye.json": 9621,
	"./testimonials/floriane.json": 4877,
	"./testimonials/laurine-koffi.json": 3873,
	"./testimonials/pierre-dubois.json": 6371,
	"./testimonials/sophie-martin.json": 2091,
	"./testimonials/thomas-bernard.json": 9534
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;